import React from 'react'
import AssignCard from '../../../board/components/Kanban/AssignCard';
import { useSelector } from 'react-redux';
import { isAdmin } from '../../../../utils/constants';

function AssigneUser({card}) {
     const currentUser = useSelector((state) => state.users.logInUser);
       const { user_id: currentUserId } = currentUser || {};

      const checkOwnerOrAdmin =  isAdmin() ||
          currentUserId === card.board.owner_user_id;

      const accessForAssign =
        checkOwnerOrAdmin ||
        currentUserId === card?.reporter ||
        card?.assigned_to_user_id == currentUserId ||
        card?.is_card_collaborator;

  return (
    <div>
      <AssignCard
        tooltipName={""}
        project={card}
        name={""}
        accessForAssign={accessForAssign}
        cardId={card?.card_id}
        isShowAssignedCards={true}
        isTodo={card?.is_todo}
        accessForQuickTask={
          card?.todo_column !== "Accepted" &&
          (checkOwnerOrAdmin || currentUserId == card?.reporter)
        }
      />
    </div>
  );
}

export default AssigneUser